<template>
  <div>
    <div class="header-screen" :class="fixed ? 'fixed' : ''">
      <div class="select-distance" @click="openSelect">
        {{ distanceActive.name
        }}<img src="../../../../picture/index/select.png" class="select-icon" />
      </div>
      <div class="header-screen-flex">
        <div scroll-x="true" class="screen-scroll" id="city-scroll">
          <div class="screen-list">
            <div
              class="screen-item"
              :class="item.checked ? 'active' : ''"
              v-for="(item, index) in screenList"
              :key="index"
              @click="screenClick(item, index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="fixed" class="null-box"></div>
    <pi-popup-content ref="popupContent" type="bottom">
      <van-picker
        title="选择距离"
        show-toolbar
        value-key="name"
        :columns="distanceList"
        @confirm="distanceChange"
        @cancel="onCancel"
        :default-index="distanceIndex"
      />
    </pi-popup-content>
  </div>
</template>

<script>
import { Picker } from "vant";
import popupContent from "@/components/pi-popup-content/pi-popup-content.vue";
export default {
  name: "pi-header-screen",
  components: {
    [Picker.name]: Picker,
    [popupContent.name]: popupContent,
  },
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      screenList: [
        {
          checked: false,
          name: "只看空闲",
          id: 1,
          key: "pileStatus",
          active: 0,
        },
        {
          checked: false,
          name: "直流",
          id: 1,
          key: "speedTypes",
          dataType: "array",
          active: 1,
        },
        {
          checked: false,
          name: "交流",
          id: 2,
          key: "speedTypes",
          dataType: "array",
          active: 2,
        },
      ],
      screenActive: [],
      distanceList: [
        {
          value: "100",
          name: "全部",
        },
        {
          value: "5",
          name: "距离5km",
        },
        {
          value: "10",
          name: "距离10km",
        },
        {
          value: "15",
          name: "距离15km",
        },
        {
          value: "20",
          name: "距离20km",
        },
        {
          value: "25",
          name: "距离25km",
        },
      ],
      distanceActive: {
        value: "100",
        name: "全部",
      },
      distanceIndex: 0,
    };
  },
  mounted() {},
  methods: {
    /**
     * 赋值，data 和给出去的值一样
     * @param {*} e
     */
    changeValue(data) {
      let screenList = this.screenList;
      let speedTypes = data.speedTypes || [];
      screenList.map((item) => {
        if (item.checked) {
          item.checked = false;
        }
        if (item.key == "pileStatus" && data.pileStatus == item.id) {
          item.checked = true;
        } else if (
          item.key == "speedTypes" &&
          speedTypes.indexOf(item.id) != -1
        ) {
          item.checked = true;
        }
      });
      let index = 0;
      if (data.distance != null) {
        index = this.distanceList.findIndex((item) => {
          return item.value == data.distance;
        });
      }
      this.screenList = screenList;
      this.distanceIndex = index;
      this.distanceActive = this.distanceList[index];
    },
    /**
     * 选择距离
     * @param {*}
     */
    distanceChange(value, index) {
      this.distanceIndex = index;
      this.distanceActive = this.distanceList[index];
      this.changeData();
      this.onCancel();
    },
    /**
     * 选择标签
     * @param {*} e
     */
    screenClick(item, index) {
      this.screenList[index].checked = !item.checked;
      this.changeData();
    },
    /**
     * 返回值
     */
    changeData() {
      let data = {
        speedTypes: [],
        pileStatus: "",
        distance:
          this.distanceIndex == 0
            ? null
            : this.distanceList[this.distanceIndex].value,
      };
      this.screenList.map((item) => {
        if (item.checked) {
          if (item.dataType == "array") {
            data[item.key].push(item.id);
          } else {
            data[item.key] = item.id;
          }
        }
      });
      data.id = this.id;
      this.$emit("change", data);
    },
    openSelect() {
      this.$refs.popupContent.open();
    },
    onCancel() {
      this.$refs.popupContent.close();
    },
  },
};
</script>

<style lang="less" scoped>
.header-screen {
  height: 0.88rem;
  box-sizing: border-box;
  padding: 0.24rem 0;
  color: #666666;
  display: flex;
  background-color: #f5f5f5;
}
.header-screen.null-box{
  height: 0.88rem;
}
.header-screen.fixed {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  box-sizing: border-box;
}
.select-distance {
  padding: 0 0.2rem;
  line-height: 0.4rem;
  height: 0.4rem;
  display: flex;
  justify-items: center;
  align-items: center;
  font-size: 0.28rem;
}
.select-distance .select-icon {
  width: 0.2rem;
  height: 0.12rem;
  margin-left: 0.2rem;
  vertical-align: middle;
}
.header-screen-flex {
  flex: 1;
  border-left: 0.01rem solid #999999;
  overflow: hidden;
  line-height: 0.4rem;
  height: 0.4rem;
}
.header-screen-flex .screen-scroll {
  width: 100%;
  overflow-x: auto;
}
.header-screen-flex .screen-list {
  padding-left: 0.2rem;
  font-size: 0;
}
.header-screen-flex .screen-list .screen-item {
  padding: 0rem 0.1rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  height: 0.4rem;
  display: inline-block;
  margin-left: 0.1rem;
  vertical-align: top;
}
.header-screen-flex .screen-list .screen-item:first-child {
  margin-left: 0;
}
.header-screen-flex .screen-list .screen-item.active {
  color: #14cc80;
}
</style>
